import { CommonModule } from '@angular/common';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Labels } from '@core/constants/labels';
import { Image } from '@core/models/image.model';
import { SlideService } from '@core/services/slide-service/slide-service.service';
import { environment } from '@environment/environment';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-register-image',
  standalone: true,
  imports: [MatProgressBarModule, MatProgressSpinnerModule, CommonModule],
  templateUrl: './register-image.component.html',
  styleUrl: './register-image.component.scss',
})
export class RegisterImageComponent implements OnDestroy {
  labels = Labels.UPLOAD_IMAGE;
  subscriptions = new Subscription();

  @Output() newImageIds = new EventEmitter<
    {
      image: Image;
      id: number;
      ready: boolean;
      name: string;
      currentlyUploading: boolean;
      file: any;
    }[]
  >();

  files: any = null;
  @Input() currentImagesData: {
    image: Image;
    id: number;
    ready: boolean;
    name: string;
    currentlyUploading: boolean;
    file: any;
  }[] = [];

  uploadProgress: number = 0;

  thumbUrl = `${environment.slideManagerUrl}/slide/thumb`;

  @ViewChild('fileField') fileSelector: any;

  constructor(
    private slideService: SlideService,
    private toastrService: ToastrService,
  ) {}

  handleFileChange(event: any): void {
    this.files = Array.from(event.target.files);
    this.currentImagesData = this.currentImagesData.concat(
      this.files.map((x: any) => {
        return {
          image: null,
          id: -1,
          ready: false,
          name: x.name,
          currentlyUploading: false,
          file: x,
        };
      }),
    );
    this.uploadSlides();
  }

  triggerSelection() {
    this.fileSelector?.nativeElement?.click();
  }

  uploadNextSlide(): void {
    if (this.files === undefined) {
      return;
    }
    const notUploaded = this.currentImagesData.filter(
      (c) => !c.currentlyUploading && !c.ready,
    );
    if (!notUploaded?.length) {
      return;
    }
    const willUpload = notUploaded[0];
    willUpload.currentlyUploading = true;

    const progressSubscription = this.slideService
      .uploadSlide(willUpload.file)
      .subscribe({
        next: (event) => this.processHttpEvent(event),
        error: (err) => {
          this.toastrService.error(this.labels.ERROR_FAILED_UPLOAD);
          this.uploadProgress = 0;
          this.fileSelector.nativeElement.value = '';
          const failedUpload = this.currentImagesData.find(
            (img) => img.currentlyUploading,
          );
          this.currentImagesData = this.currentImagesData.filter(
            (img) => img !== failedUpload,
          );
          this.newImageIds.emit(this.currentImagesData);
        },
      });
    this.subscriptions.add(progressSubscription);
  }

  uploadSlides(): void {
    if (this.files === null || !this.files?.length) {
      return;
    }
    this.uploadNextSlide();
  }

  processHttpEvent(event: HttpEvent<any>) {
    let imageId;
    let eventTotal;
    let data: any;
    switch (event.type) {
      case HttpEventType.Response:
        this.uploadProgress = 100;
        this.fileSelector.nativeElement.value = '';

        imageId = +event?.body?.id;

        data = this.currentImagesData.filter((c) => c.currentlyUploading)[0];
        data.id = imageId;
        data.image = event?.body;
        data.ready = true;
        data.currentlyUploading = false;

        this.newImageIds.emit(this.currentImagesData);
        this.uploadProgress = 0;

        this.uploadNextSlide();
        break;
      case HttpEventType.UploadProgress:
        eventTotal = event.total ? event.total : 0;
        this.uploadProgress = Math.round((event.loaded / eventTotal) * 100.0);
        break;
      default:
        break;
    }
  }

  removeImage(image: Image) {
    this.currentImagesData = this.currentImagesData.filter(
      (c) => c.id !== image.id,
    );
    //this.currentImages = this.currentImages.filter((c) => c.id !== image.id);
    //this.currentImageIds = this.currentImageIds.filter((c) => c !== image.id);
    this.newImageIds.emit(this.currentImagesData);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
